<template>
  <svg width="16px" height="16px"
       viewBox="0 0 16 16" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/16x16/exclamation/white</title>
    <g id="atoms/icons/16x16/exclamation/white" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <g id="Group" transform="translate(8, 7.75) scale(1, -1) translate(-8, -7.75)translate(6.75, 1.5)"
      >
        <path d="M1.25,3.5 C1.67077799,3.5 2.01826195,3.82871513 2.04160251,4.24884526 L2.44136278,11.44453 C2.47199802,11.9959644 2.04980687,12.4678251 1.49837244,12.4984604 C1.47990024,12.4994866 1.46140311,12.5 1.44290242,12.5 L1.05709758,12.5 C0.504812827,12.5 0.0570975765,12.0522847 0.0570975765,11.5 C0.0570975765,11.4814993 0.0576109897,11.4630022 0.0586372233,11.44453 L0.458397485,4.24884526 C0.481738048,3.82871513 0.829222013,3.5 1.25,3.5 Z" id="Rectangle"></path>
        <circle id="Oval" cx="1.25"
                cy="1.25" r="1.25"></circle>
      </g>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
